import { property, subclass } from "@arcgis/core//core/accessorSupport/decorators";
import Accessor from "@arcgis/core/core/Accessor";
import Collection from "@arcgis/core/core/Collection";

@subclass("SearchBoxViewModel")
export default class SearchBoxViewModel extends Accessor {

  @property()
  appMessages: any;

  /** Extra tags that should be excluded from the Search Suggestions */
  @property({ readOnly: true })
  readonly searchSuggestionsExclude: Collection<string> = new Collection([
    "ArcGIS web application template",
    "express setup", 
    "instant apps", 
    "instant mapping apps", 
    "4.x"
  ])

  @property({ readOnly: true })
  searchSuggestions: Collection<string>;

  @property({ readOnly: true })
  searchResults: Collection<string> = new Collection();

  @property({ readOnly: true })
  currentSearchValue: string = null;

  constructor(params?: any) {
    super(params);
  }

  handleSearch(e: CustomEvent): void {
    const { value } = e.detail;
    if (this.currentSearchValue === value) {
      return;
    }
    this._set("currentSearchValue", value);
    this._generateSearchResults(value);
  }

  setSearchSuggestions(suggestions: Collection<string>){
    this._set("searchSuggestions", suggestions);
  }

  private _generateSearchResults(value: string): void {
    const results = this._getFilteredSearchResults(value);
    this.searchResults.removeAll();
    this.searchResults.addMany(results);
  }

  private _getFilteredSearchResults(value: string): Collection<string> {
    const lowercaseVal = value.toLocaleLowerCase();
    const results = this.searchSuggestions.filter((searchTerm:string) => {
      return searchTerm
                .toLocaleLowerCase()
                .trim()
                .indexOf(lowercaseVal) !== -1;
    });

    results.sort((a: string, b: string)=>{
      var aIndex = a.toLocaleLowerCase().indexOf(lowercaseVal);
      var bIndex = b.toLocaleLowerCase().indexOf(lowercaseVal);
      return aIndex - bIndex;
    });
    
    return results;
  }
}
